// components/NewsletterSignup.jsx
import React, { useState } from 'react';
import { subscribeToNewsletter } from '../utils/newsletter';

export default function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleSubscribe = async (event) => {
    event.preventDefault();
    setStatus('submitting');
    setMessage('');

    try {
      await subscribeToNewsletter(email, 'homepage');
      setEmail('');
      setStatus('success');
      setMessage('Thanks for subscribing!');
    } catch (error) {
      console.error('Newsletter subscription failed:', error);
      setStatus('error');
      setMessage(error.code === 'permission-denied' ? 'This email may already be subscribed.' : 'Subscription failed. Please try again.');
    }
  };

  return (
    <section className="mt-10 bg-accent px-4 py-8 text-center text-white sm:rounded-t-lg sm:px-8">
      <h3 className="mb-3 text-2xl font-bold">Stay Informed</h3>
      <p className="mx-auto mb-6 max-w-xl text-base leading-relaxed">
        Join our mailing list to get updates on new products, jobs, and helpful tech tips.
      </p>
      <form onSubmit={handleSubscribe} className="max-w-md mx-auto flex flex-col sm:flex-row items-center gap-4">
        <input
          type="email"
          name="newsletter-email"
          placeholder="Your email address"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          autoComplete="email"
          className="w-full rounded-md px-4 py-3 text-black outline-none sm:flex-1 sm:py-2"
          required
          disabled={status === 'submitting'}
        />
        <button
          type="submit"
          disabled={status === 'submitting'}
          className="w-full rounded-full bg-primary px-4 py-2 text-sm font-semibold transition hover:bg-white hover:text-primary disabled:cursor-not-allowed disabled:opacity-70 sm:w-auto"
        >
          {status === 'submitting' ? 'Subscribing...' : 'Subscribe'}
        </button>
      </form>
      {message && (
        <p role="status" aria-live="polite" className={`mx-auto mt-3 max-w-md text-sm ${status === 'error' ? 'text-red-100' : 'text-white'}`}>
          {message}
        </p>
      )}
    </section>
  );
}
